export const MAX_TOKENS = 5;

export const TOKEN_COLORS = {
  BTC: '#F7931A',
  ETH: '#627EEA',
  XRP: '#FFFFFF',
  SOL: '#14F195',
  DOT: '#E6007A',
  ADA: '#0033AD',
  AVAX: '#E84142',
  LINK: '#2A5ADA',
  MATIC: '#8247E5',
  UNI: '#FF007A',
};
